import { useMutation } from '@tanstack/react-query';
import { findById, getAll } from '../requests/company';

const KEY = 'company';

const useFindById = () => useMutation({
  mutationKey: [KEY],
  mutationFn: (data) => findById(data),
});

const useGetAllCompanies = () => useMutation({
  mutationKey: [KEY, 'getAll'],
  mutationFn: () => getAll(),
});

const companyMutation = {
  useFindById,
  useGetAllCompanies,
};

export default companyMutation;
